import { Environment, CameraControls, Html, PerspectiveCamera } from '@react-three/drei'
import { EffectComposer, Autofocus } from '@react-three/postprocessing'
import { useThree } from '@react-three/fiber'
import { useEffect, useRef } from 'react'
import useGame from './stores/useGame.jsx'
import * as THREE from'three'
import { Arm } from './robotArm.jsx'
import { Leva, useControls } from 'leva'
import { Mars } from './Mars.jsx'
import { Bloom,  Noise,  Vignette } from '@react-three/postprocessing'
import { Resolution, BlendFunction, KernelSize } from 'postprocessing'



const { DEG2RAD } = THREE.MathUtils

var audioTrigger = false
var start = false

export default function Experience()
{
    const phase = useGame((state) => state.phase)
    const touched = useGame((state) => state.touched)
  const play = useGame((state) => state.play)

    const animFinished = useGame((state) => state.animFinished)
    
    const cameraControlsRef = useRef()

    const p1 = useGame((state) => state.p1)
    const p2 = useGame((state) => state.p2)
    const p3 = useGame((state) => state.p3)
    const p4 = useGame((state) => state.p4)
    const p5 = useGame((state) => state.p5)
    const p6 = useGame((state) => state.p6)
    const p7 = useGame((state) => state.p7)

    const infoPanel = useGame((state) => state.infoPanel)

    const efRef = useRef()
    const dofRef = useRef()

    const {...efConfig} = useControls('PostProcessing',{
        enabled: true
    })

    const globalSmoothTime = useRef(0)
    
    const {...dofConfig} = useControls('DOF',{
        focalLength: {value: 1, min: 0.00, max: 0.50, step: 0.01},
        focusRange: { min: 0, max: 1, value: 0.1 },
        bokehScale: {value: 4.0, min: 0.0, max: 5.0, step: 0.1}
    })

    const state = useThree()

    useEffect(() =>
    {
        const scene = useGame.getState()
                
        if(scene.infoPanel === 'null')
            {
            var position = new THREE.Vector3(6, 10, 6)
            var target = new THREE.Vector3(0, 8, 1)

            cameraControlsRef.current.setLookAt(...position, ...target, true)
            cameraControlsRef.current.smoothTime = globalSmoothTime.current
            cameraControlsRef.current.truckSpeed = 1
            cameraControlsRef.current.dollySpeed = 1
            cameraControlsRef.current.polarRotateSpeed = 1
            cameraControlsRef.current.azimuthRotateSpeed = 1
            cameraControlsRef.current.minDistance = 6
            }
    }, [infoPanel, state.camera])



        const LaunchPoint = (panelNumber, position, target) =>
        {
            panelNumber()
            console.log(position)
            console.log(target)
            globalSmoothTime.current = 1
            cameraControlsRef.current.smoothTime = globalSmoothTime.current
            cameraControlsRef.current.setLookAt(...position, ...target, true)
            
        }


        const Points = () =>
            {

            return  <>

                    {play === false &&  infoPanel === 'null' &&<>
                        <Html wrapperClass='point' position={new THREE.Vector3(-0.0,10.25,0.8)}  > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(-1.6,10.2,1.6), new THREE.Vector3(-0,9.8,0.5)) } }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p1, new THREE.Vector3(-1.6,10.2,1.6), new THREE.Vector3(-0,9.8,0.5)) } }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.0,10,-1.25)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p2, new THREE.Vector3(-2,10.2,-0.8), new THREE.Vector3(-0,9.6,-1.35))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p2, new THREE.Vector3(-2,10.2,-0.8), new THREE.Vector3(-0,9.6,-1.35))} }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(-0.0,10.25,2)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p3, new THREE.Vector3(-1.5,10.5,2.15), new THREE.Vector3(-0.0,9.6,2))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p3, new THREE.Vector3(-1.5,10.5,2.15), new THREE.Vector3(-0.0,9.6,2))} }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0,9.0,0.2)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p4, new THREE.Vector3(1.75,9.25,0.4), new THREE.Vector3(-0.0,9.25,0.4))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p4, new THREE.Vector3(1.75,9.25,0.4), new THREE.Vector3(-0.0,9.25,0.4))} }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.0,9.6,4.15)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p5, new THREE.Vector3(1,10.2,5), new THREE.Vector3(0.0,9.6,3.75))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p5, new THREE.Vector3(1,10.2,5), new THREE.Vector3(0.0,9.6,3.75))} }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.0,8,1.3)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(1.5,8,2), new THREE.Vector3(0.5, 8,1.3))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p6, new THREE.Vector3(1.5,8,2), new THREE.Vector3(0.5, 8,1.3))} }></div> 
                        </Html>

                        <Html wrapperClass='point' position={new THREE.Vector3(0.0,6.9,1.5)} > 
                            <div className="pulse" onClick={()=> { LaunchPoint(p7, new THREE.Vector3(1,8.0,2.7), new THREE.Vector3(0.0,6.9,0.15))} }></div>
                            <div className="label" onClick={()=> { LaunchPoint(p7, new THREE.Vector3(1,8.0,2.7), new THREE.Vector3(0.0,6.9,0.15))} }></div> 
                        </Html>
                        </>
                    }
                    </>
            }
    


     return <>
            <Leva hidden={true} />
                <directionalLight 
                    color={new THREE.Color( 0xffffff )}
                    position={[0 , 10, 15]} 
                    intensity={ 3 } 
                    castShadow 
                    shadow-mapSize={[4096, 4096]}
                    shadow-bias={-0.0001}
                    shadow-camera-top={10}
                    shadow-camera-bottom={-10}
                    shadow-camera-left={-20}
                    shadow-camera-right={20}
                    
                    
                    />








                <directionalLight 
                    color={new THREE.Color( 0xffffff )}
                    position={[0 , 9, -15]} 
                    intensity={ 5 } 
                    castShadow 
                    shadow-mapSize={[4096, 4096]}
                    shadow-bias={-0.0001}
                    shadow-camera-top={10}
                    shadow-camera-bottom={-10}
                    shadow-camera-left={-20}
                    shadow-camera-right={20}
                    
                    />



                
                <Environment 
                    files="studio.exr"
                    background  
                    environmentIntensity={0.55}
                    backgroundIntensity={1.5}
                    backgroundBlurriness={0}

                    ground={{
                                height: 25, // Height of the camera that was used to create the env map (Default: 15)
                                radius: 80, // Radius of the world. (Default 60)
                                scale: 55, // Scale of the backside projected sphere that holds the env texture (Default: 1000)
                            }}   
                    
                />
                
                
                <CameraControls
                        ref={cameraControlsRef}
                        minDistance={8}
                        maxDistance={12}
                        minPolarAngle={Math.PI/2 - 0.8}
                        maxPolarAngle={Math.PI/2 - 0.1}
                        makeDefault
                        smoothTime={1}
                        polarRotateSpeed={0}
                        azimuthRotateSpeed={0}
                        truckSpeed={0}
                        dollySpeed={0}
                        
                />

                    <PerspectiveCamera 
                        fov= {60}
                        near={0.1}
                        far={2000}
                        position= {[ 8, 10, 8 ]}
                        makeDefault
                    />

                                    


                    
                    <Arm scale={[0.5,0.5,0.5]} position={[0,7,0]}/>
                    
                   
                    <Points/>
                    
                    
                    <EffectComposer ref={efRef} {...efConfig}>
            


                    <Bloom
                        intensity={0.25} // The bloom intensity.
                        kernelSize={KernelSize.LARGE} // blur kernel size
                        luminanceThreshold={0.9} // luminance threshold. Raise this value to mask out darker elements in the scene.
                        luminanceSmoothing={0.025} // smoothness of the luminance threshold. Range is [0, 1]
                        mipmapBlur={true} // Enables or disables mipmap blur.
                        resolutionX={Resolution.AUTO_SIZE} // The horizontal resolution.
                        resolutionY={Resolution.AUTO_SIZE} // The vertical resolution.
                    />

                    <Noise
                        premultiply // enables or disables noise premultiplication
                        blendFunction={BlendFunction.DARKEN} // blend mode
                        opacity={0.5}

                    />

                    <Vignette
                        offset={0.1} // vignette offset
                        darkness={0.9} // vignette darkness
                        eskil={false} // Eskil's vignette technique
                        blendFunction={BlendFunction.DARKEN} // blend mode
                        opacity={1}
                    />


                    
                    </EffectComposer>
                        
                        

                 
                        


    </>
}